module.exports = __webpack_public_path__ + "img/jljj-tab-pc.f6907f66.svg";